export default "__VITE_ASSET__BXJk4WMa__"